import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
// componentes
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// moment
import moment from "moment";
// service
import { updateStockActivity } from "../../../utils/services/schedulingAndStock";
import { getGroups } from "../../../utils/services/group";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";

export default function ModalEditStock(props) {
  const { isOpen, toggle, data, jwt, refetch, idEvent } = props;

  // Carregamento
  const [loading, setLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false); // Alerta de erro
  const [showSubmitErrorAlert, setShowSubmitErrorAlert] = useState(false);
  // erro
  const [quantityErro, setQuantityErro] = useState("");
  // campos dinamicos
  const [separateByGroups, setSeparateByGroups] = useState(
    data?.segregarPorGrupo ? "Sim" : "Não",
  );
  const [groupAdd, setGroupAdd] = useState("");
  const [quantityAdd, setQuantityAdd] = useState(0);
  const [allGroupsAdd, setAllGroupsAdd] = useState([]);
  // lista de grupos
  const [groupsApi, setGroupsApi] = useState([]);

  const formatDateToInput = (date) => {
    return moment(date).add(3, "hours").format("YYYY-MM-DDTHH:mm");
  };

  const [formEdit, setFormEdit] = useState({
    room: data.sala,
    activity: data.atividade,
    initialDate: formatDateToInput(data.dataHoraInicio),
    endDate: formatDateToInput(data.dataHoraFim),
    maxQuantity: data.quantidadeMax,
    quantityUsed: data.quantidadeUtilizada || 0,
    tipo: data?.tipo,
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormEdit((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const newErrors = {};
    if (!formEdit.room) newErrors.room = "O campo Sala é obrigatório";
    if (!formEdit.activity)
      newErrors.activity = "O campo Atividade é obrigatório";
    if (!formEdit.initialDate)
      newErrors.initialDate = "O campo Data e Hora Inicio é obrigatório";
    if (!formEdit.endDate)
      newErrors.endDate = "O campo Data e Hora Fim é obrigatório";
    if (formEdit.endDate && formEdit.endDate < formEdit.initialDate)
      newErrors.endDate =
        "A Data e Hora Fim não pode ser menor que a Data e Hora Inicio.";
    if (!formEdit.maxQuantity || formEdit.maxQuantity <= 0)
      newErrors.maxQuantity =
        "O campo Quantidade Máxima é obrigatório e deve ser maior que 0";

    if (Number(formEdit.maxQuantity) < Number(formEdit.quantityUsed)) {
      setShowErrorAlert(true);
      setLoading(false);
      return;
    }

    if (separateByGroups === "Sim" && allGroupsAdd.length < 1)
      newErrors.groupAdd = "Adicione pelo menos um grupo";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoading(false);
      return;
    }

    try {
      const dataForm = {
        ...formEdit,
        segregarPorGrupo: separateByGroups === "Sim",
        grupos: allGroupsAdd.map((e) => {
          return {
            groupId: e.group,
            quantidade: e.quantity,
          };
        }),
      };

      await updateStockActivity(data.id, dataForm, jwt);
      refetch();
      setShowSuccessAlert(true);
    } catch (error) {
      console.error("Erro ao atualizar atividade de estoque:", error);
      setShowSubmitErrorAlert(true);
    } finally {
      setLoading(false);
    }
  };

  function addGroup() {
    setErrors({
      ...errors,
      groupAdd: null,
    });

    if (!groupAdd || !quantityAdd) {
      setErrors({
        ...errors,
        groupAdd: "Insira todos os dados para adicionar",
      });
      return;
    }

    var used = 0;

    allGroupsAdd.forEach((e) => {
      used = used + Number(e.quantity);
    });

    if (Number(formEdit.maxQuantity) - used < quantityAdd) {
      setErrors({
        ...errors,
        groupAdd: "Quantidade Indisponível",
      });
      return;
    }

    const dataAdd = {
      group: groupAdd,
      quantity: Number(quantityAdd),
    };

    setAllGroupsAdd([...allGroupsAdd, dataAdd]);

    setGroupAdd("");
    setQuantityAdd(0);
  }

  function removeGroup(index) {
    var groups = allGroupsAdd;

    groups = groups.filter((e, i) => i !== index);

    setAllGroupsAdd(groups);
  }

  function editGroup(index, field, value, min) {
    if (field === "quantity") {
      // validar se a alteração esta dentro do valor maximo
      var used = 0;

      allGroupsAdd.forEach((e, i) => {
        if (i === index) return;

        used = used + Number(e.quantity);
      });

      if (used + Number(value) > formEdit.maxQuantity) {
        value = formEdit.maxQuantity - used;
      }

      if (value < min) {
        value = min;
      }
    }

    const groups = allGroupsAdd.map((group, i) =>
      i === index ? { ...group, [field]: value } : group,
    );

    setAllGroupsAdd(groups);
  }

  function changeMaxQuantity(value) {
    var used = 0;

    allGroupsAdd.forEach((e) => {
      used = used + Number(e.quantity);
    });

    if (value < used) {
      value = used;
    }

    setFormEdit((prev) => ({
      ...prev,
      maxQuantity: value,
    }));
  }

  function getGroupsListSaved() {
    var groupsAdd = [];

    data.grupos.forEach((e) => {
      groupsAdd.push({
        group: e.groupId,
        quantity: Number(e.quantidade),
        quantityUsed: Number(e.quantidadeUtilizada),
      });
    });

    setAllGroupsAdd(groupsAdd);
  }

  useEffect(() => {
    getGroups({
      eventId: idEvent,
      offset: 1,
      limit: 10000,
      search: "",
    })
      .then((res) => {
        if (res?.message === "Groups_by_event") {
          setGroupsApi(res.findOneGroupData.data);
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar grupos:", error);
        toast.error("Erro ao buscar os grupos.");
      });
  }, [idEvent]);

  useEffect(() => {
    if (groupsApi && groupsApi.length > 0 && data.grupos.length > 0) {
      getGroupsListSaved();
    }
  }, [groupsApi]);

  return (
    <>
      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Editar Estoque</ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col lg={12} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">ID</label>
                  <input
                    className="form-control"
                    type="text"
                    value={data.id}
                    disabled
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Sala*</label>
                  <input
                    className="form-control"
                    type="text"
                    name="room"
                    value={formEdit.room}
                    onChange={handleChange}
                  />
                  {errors.room && (
                    <div style={{ color: "red" }}>{errors.room}</div>
                  )}
                </div>
              </Col>

              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Atividade*</label>
                  <input
                    className="form-control"
                    type="text"
                    name="activity"
                    value={formEdit.activity}
                    onChange={handleChange}
                  />
                  {errors.activity && (
                    <div style={{ color: "red" }}>{errors.activity}</div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Data e Hora Inicio*</label>
                  <input
                    className="form-control"
                    type="datetime-local"
                    name="initialDate"
                    value={formEdit.initialDate}
                    onChange={handleChange}
                  />
                  {errors.initialDate && (
                    <div style={{ color: "red" }}>{errors.initialDate}</div>
                  )}
                </div>
              </Col>

              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Data e Hora Fim*</label>
                  <input
                    className="form-control"
                    type="datetime-local"
                    name="endDate"
                    value={formEdit.endDate}
                    onChange={handleChange}
                    min={formEdit.initialDate}
                  />
                  {errors.endDate && (
                    <div style={{ color: "red" }}>{errors.endDate}</div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Tipo</label>
                  <input
                    className="form-control"
                    type="text"
                    name="tipo"
                    value={formEdit.tipo}
                    onChange={handleChange}
                  />
                </div>
              </Col>
              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Quantidade Máxima*</label>
                  <input
                    className="form-control"
                    type="number"
                    name="maxQuantity"
                    value={formEdit.maxQuantity}
                    onChange={(e) => {
                      changeMaxQuantity(Number(e.target.value));
                      // tranformar em number para remover o 0 inicial
                      e.target.value = Number(e.target.value);
                    }}
                  />
                  {errors.maxQuantity && (
                    <div style={{ color: "red" }}>{errors.maxQuantity}</div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12} style={{ marginBottom: 10 }}>
                <label className="form-label">
                  Segregar quantidade de vagas por grupo?
                </label>

                <select
                  className="form-control"
                  onChange={(e) => {
                    setSeparateByGroups(e.target.value);

                    setAllGroupsAdd([]);
                  }}
                  value={separateByGroups}
                >
                  <option>Não</option>
                  <option>Sim</option>
                </select>
              </Col>
            </Row>

            {separateByGroups === "Sim" && (
              <>
                <Row>
                  <Col md={9} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col lg={6}>
                        <label className="form-label">Grupo</label>
                        <select
                          className="form-control"
                          onChange={(e) => {
                            setGroupAdd(e.target.value);
                            setErrors({
                              ...errors,
                              groupAdd: null,
                            });
                          }}
                          value={groupAdd}
                        >
                          <option>Selecione</option>
                          {groupsApi &&
                            groupsApi.length > 0 &&
                            groupsApi.map((group, index) => {
                              if (
                                !allGroupsAdd.find((e) => e.group === group.id)
                              )
                                return (
                                  <option
                                    key={`optionGroup${index}`}
                                    value={group.id}
                                  >
                                    {group.name}
                                  </option>
                                );
                            })}
                        </select>
                      </Col>
                      <Col lg={6}>
                        <label className="form-label">Quantidade</label>
                        <input
                          className="form-control"
                          type="number"
                          onChange={(e) => {
                            setQuantityAdd(e.target.value);
                            setErrors({
                              ...errors,
                              groupAdd: null,
                            });
                          }}
                          value={quantityAdd}
                        />
                      </Col>
                    </Row>
                  </Col>

                  <Col
                    md={3}
                    className="mt-3"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      color="success"
                      className="btn btn-success waves-effect waves-light"
                      style={{ width: 80 }}
                      onClick={() => addGroup()}
                    >
                      Adicionar
                    </Button>
                  </Col>
                  {errors && errors.groupAdd && (
                    <a style={{ color: "red" }}>{errors.groupAdd}</a>
                  )}
                </Row>

                {allGroupsAdd &&
                  allGroupsAdd.length > 0 &&
                  allGroupsAdd.map((e, i) => (
                    <div
                      style={{
                        border: "1px solid #a1e2de",
                        margin: "20px 0",
                        padding: 10,
                        borderRadius: 8,
                      }}
                      key={e.group}
                    >
                      <Row>
                        <Col lg={8}>
                          <label className="form-label">Grupo</label>
                          <select
                            className="form-control"
                            value={e.group}
                            onChange={(value) =>
                              editGroup(i, "group", value.target.value)
                            }
                          >
                            <option>
                              {groupsApi.find((group) => group.id === e.group)
                                ?.name || "-"}
                            </option>
                            {groupsApi &&
                              groupsApi.length > 0 &&
                              groupsApi.map((group, index) => {
                                if (
                                  !allGroupsAdd.find(
                                    (e) => e.group === group.id,
                                  )
                                )
                                  return (
                                    <option
                                      key={`optionGroup${index}`}
                                      value={group.id}
                                    >
                                      {group.name}
                                    </option>
                                  );
                              })}
                          </select>

                          <label
                            className="form-label"
                            style={{ marginTop: 10 }}
                          >
                            Quantidade
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            onChange={(value) => {
                              // tranformar em number para remover o 0 inicial
                              value.target.value = Number(value.target.value);

                              editGroup(
                                i,
                                "quantity",
                                Number(value.target.value),
                                Number(e.quantityUsed),
                              );
                            }}
                            value={Number(e.quantity)}
                          />

                          <label
                            className="form-label"
                            style={{ marginTop: 10 }}
                          >
                            Quantidade utilizada
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            disabled
                            value={Number(e.quantityUsed)}
                          />
                        </Col>

                        <Col
                          md={4}
                          className="mt-3"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            color="success"
                            className="btn btn-danger waves-effect waves-light"
                            style={{ width: 80 }}
                            onClick={() => removeGroup(i)}
                          >
                            Remover
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))}
              </>
            )}

            <Row
              style={{
                width: "100%",
                margin: "20px auto 0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="danger"
                style={{ width: 80 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>
              <ButtonSpinner
                isLoading={loading}
                title={"Salvar"}
                marginLeft={10}
                action="U"
              />
            </Row>
          </form>
        </ModalBody>
      </Modal>

      {showSuccessAlert && (
        <SweetAlert
          title={`Editado`}
          success
          onConfirm={() => {
            setShowSuccessAlert(false);
            toggle();
          }}
        >
          Atividade editada com sucesso!
        </SweetAlert>
      )}

      {showErrorAlert && (
        <SweetAlert
          title={`Erro`}
          danger
          onConfirm={() => setShowErrorAlert(false)}
        >
          Quantidade máxima não pode ser menor que a quantidade utilizada!
        </SweetAlert>
      )}

      {showSubmitErrorAlert && (
        <SweetAlert
          title="Erro"
          danger
          onConfirm={() => setShowSubmitErrorAlert(false)}
        >
          Erro ao atualizar a atividade de estoque.
        </SweetAlert>
      )}
    </>
  );
}
